module.exports = __webpack_public_path__ + "img/teacher.37a77a7e.jpg";